import gql from 'graphql-tag'

export default gql`mutation ($data: NotificationInput!) {
  editNotification(data: $data) @client
}`